import { Attendance, Res } from '@/types'

import base from './base'

export const attendancesApi = base.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTeachingAttendances: builder.query<Attendance[], string>({
      query: (id) => `teachers/attendances/${id}`,
      transformResponse: (res: Res<Attendance[]>) => res.data,
      providesTags: ['Attendances'],
    }),

    sendAttendances: builder.mutation<void, { id: string; attendances: Attendance[] }>({
      query: ({ id, attendances }) => ({
        url: `teachers/attendances/${id}`,
        method: 'POST',
        body: { attendances },
      }),
      invalidatesTags: ['Attendances'],
    }),
  }),
})

export const { useLazyGetTeachingAttendancesQuery, useSendAttendancesMutation } =
  attendancesApi
